// @ts-nocheck
import { useState } from "react"
import { useNavigate, Link } from "react-router-dom"
import { supabaseClient } from "@/lib/supabase/client"
import { useToast } from "@/components/ui/ToastProvider"

export default function ResetPasswordPage() {
  const [password, setPassword] = useState("")
  const [confirm, setConfirm] = useState("")
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const { success, error: showError } = useToast()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (password.length < 8) { showError("Too short", "Password must be at least 8 characters"); return }
    if (password !== confirm) { showError("Mismatch", "Passwords do not match"); return }
    setLoading(true)
    try {
      const { error } = await supabaseClient.auth.updateUser({ password })
      if (error) { showError("Error", error.message); return }
      success("Password updated!")
      navigate("/auth/login")
    } catch (e: any) {
      showError("Failed", e.message)
    } finally { setLoading(false) }
  }

  return (
    <div className="auth-wrap" style={{ justifyContent: "center", alignItems: "center" }}>
      <div style={{ width: "100%", maxWidth: 380, padding: "1.5rem" }}>
        <div className="auth-box">
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: "1.5rem" }}>
            <SquidsIcon size={28} /><span className="sq-logo" style={{ fontSize: "1.4rem" }}>SQUIDS</span>
          </div>
          <h1 className="font-outfit font-bold text-xl mb-1">Set new password</h1>
          <p className="text-sm mb-5" style={{ color: "var(--text2)" }}>Choose a strong password for your account.</p>
          <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: ".75rem" }}>
            <div>
              <label className="text-xs font-bold uppercase tracking-wider block mb-1" style={{ color: "var(--text3)" }}>New Password</label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)}
                placeholder="8+ characters" className="sq-input" autoFocus required minLength={8} autoComplete="new-password" />
            </div>
            <div>
              <label className="text-xs font-bold uppercase tracking-wider block mb-1" style={{ color: "var(--text3)" }}>Confirm Password</label>
              <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)}
                placeholder="Repeat password" className="sq-input" required autoComplete="new-password" />
            </div>
            <button type="submit" disabled={loading || !password || !confirm} className="sq-btn sq-btn-primary" style={{ width: "100%", padding: ".6rem", justifyContent: "center" }}>
              {loading ? <Spinner /> : "Update Password"}
            </button>
          </form>
          <div style={{ textAlign: "center", marginTop: "1.25rem" }}>
            <Link to="/auth/login" style={{ fontSize: ".82rem", color: "var(--brand)", fontWeight: 600 }}>← Back to login</Link>
          </div>
        </div>
      </div>
    </div>
  )
}

function SquidsIcon({ size = 32 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
      <rect width="48" height="48" rx="10" fill="#ff4500" />
      <path d="M15 17.5C15 14.462 17.462 12 20.5 12H29C30.105 12 31 12.895 31 14C31 15.105 30.105 16 29 16H20.5C19.672 16 19 16.672 19 17.5C19 18.328 19.672 19 20.5 19H27.5C30.538 19 33 21.462 33 24.5C33 27.538 30.538 30 27.5 30H19C17.895 30 17 30.895 17 32C17 33.105 17.895 34 19 34H28.5C29.328 34 30 34.672 30 35.5C30 36.328 29.328 37 28.5 37H19C16.239 37 14 34.761 14 32C14 29.239 16.239 27 19 27H27.5C28.328 27 29 26.328 29 25.5C29 24.672 28.328 24 27.5 24H20.5C17.462 24 15 21.538 15 18.5V17.5Z" fill="white" />
    </svg>
  )
}

function Spinner() {
  return (
    <svg className="w-4 h-4 animate-spin" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" strokeOpacity=".25" />
      <path d="M12 2a10 10 0 0 1 10 10" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    </svg>
  )
}
